import Media from 'components/Content/Media/Media';

export default Media;
